import { useEffect, useState, type FormEvent } from "react";
import { api, ApiError } from "../api";
import { Button, Field, Notice } from "../components";
import { useSession } from "../session";

export function Profile() {
  const { me } = useSession();
  const [st, setSt] = useState<{ enabled: boolean; thisSession: boolean } | null>(null);
  const [setup, setSetup] = useState<{ secret: string; otpauthUri: string } | null>(null);
  const [code, setCode] = useState(""), [msg, setMsg] = useState<{ tone: "error" | "success"; text: string } | null>(null);
  useEffect(() => { api.authed("/api/v1/auth/me/mfa").then(setSt).catch(() => {}); }, []);
  async function confirm(e: FormEvent) {
    e.preventDefault(); setMsg(null);
    try { await api.authed("/api/v1/auth/me/mfa/confirm", { body: { code } }); setSetup(null); setSt({ enabled: true, thisSession: false });
      setMsg({ tone: "success", text: "Two-step verification is on. From your next sign-in you'll be asked for a code from your authenticator app." }); }
    catch (ex) { setMsg({ tone: "error", text: (ex as ApiError).message }); }
  }
  return (
    <>
      <h1>Your profile</h1>
      <dl className="kv"><div><dt>Name</dt><dd>{me?.user.fullName}</dd></div><div><dt>Email</dt><dd>{me?.user.email ?? "—"}</dd></div></dl>
      <section aria-labelledby="mfa-h" className="panel">
        <h2 id="mfa-h">Two-step verification</h2>
        {msg && <Notice tone={msg.tone}>{msg.text}</Notice>}
        {st && st.enabled && !setup && <p><strong>On.</strong> Signing in needs your password and a 6-digit code from your authenticator app.
          {" "}To turn it off or move to a new phone, contact HealthOS support (we verify your identity first).</p>}
        {st && !st.enabled && !setup && <>
          <p>Protect your account with a code from an authenticator app (Google Authenticator, Microsoft Authenticator, or similar) in addition to your password.</p>
          <Button onClick={async () => { try { setSetup(await api.authed("/api/v1/auth/me/mfa/start", { body: {} })); setMsg(null); } catch (ex) { setMsg({ tone: "error", text: (ex as ApiError).message }); } }}>
            Turn on two-step verification</Button>
        </>}
        {setup && <form className="mini-form mfa-setup" onSubmit={confirm}>
          <ol>
            <li>Open your authenticator app and add an account. On this phone you can <a href={setup.otpauthUri}>open the app directly</a>.</li>
            <li>Choose “enter a setup key” and type this key:<br /><code className="setup-key" aria-label="Setup key">{setup.secret.match(/.{1,4}/g)!.join(" ")}</code></li>
            <li>Enter the 6-digit code the app shows.</li>
          </ol>
          <Field label="6-digit code" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} />
          <div className="form-actions"><Button type="submit" disabled={code.length !== 6}>Confirm and turn on</Button><Button type="button" variant="quiet" onClick={() => setSetup(null)}>Cancel</Button></div>
        </form>}
      </section>
    </>
  );
}
